/**
 * @file
 * Patria content printing.
 */

(function ($, Drupal) {

  'use strict';


  Drupal.behaviors.print_content = {
    attach: function (context, settings) {

      if ($('#print-content').length) {
        $('#print-content').click(function() {
          printContent('.printable');
        });
      }


      // Printing function.
      function printContent(wrapper) {

        var content_to_print = $(wrapper).clone();
        content_to_print.addClass('printed-content');
        $('body').after(content_to_print);

        window.focus();
        window.print();

        setTimeout(function () { $('.printed-content').remove(); }, 3000);
      }

    }
  };

})(jQuery, Drupal);
